import React, { useState, useMemo } from "react";
import PostGrid from "./post/PostGrid";
import { posts } from "./post/AllPost";

const CategorySelector: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<
    "Lost Gem" | "Expose"
  >("Expose");

  const handleCategoryChange = (category: "Lost Gem" | "Expose") => {
    setSelectedCategory(category);
  };

  const filteredPosts = useMemo(
    () => posts.filter((post) => post.category === selectedCategory),
    [selectedCategory]
  );

  return (
    <div className="container mx-auto">
      <div
        className="flex justify-end space-x-4 pt-4"
        role="group"
        aria-label="Category filter"
      >
        <button
          onClick={() => handleCategoryChange("Expose")}
          className={`px-4 py-2 text-white ${
            selectedCategory === "Expose"
              ? "bg-[#C1282DFF] underline"
              : "bg-[#606060] hover:bg-[#C1282DFF]"
          }`}
          aria-pressed={selectedCategory === "Expose"}
          aria-label="Show Exposés"
        >
          Exposés
        </button>
        <button
          onClick={() => handleCategoryChange("Lost Gem")}
          className={`px-4 py-2 text-white ${
            selectedCategory === "Lost Gem"
              ? "bg-[#C1282DFF] underline"
              : "bg-[#606060] hover:bg-[#C1282DFF]"
          }`}
          aria-pressed={selectedCategory === "Lost Gem"}
          aria-label="Show Lost Gems"
        >
          Lost Gems
        </button>
      </div>
      <PostGrid posts={filteredPosts} />
    </div>
  );
};

export default CategorySelector;
